<template lang="pug">
div
  section.u-mt-md
    AppTitle(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    AppTitle(:title="$t('meet')" tag="h2")
    .grid.is-widescreen-7.is-desktop-9
      .column
        p.u-text-lg.u-mb-xm {{$t('meetDesc')}}

    .u-img-max.u-mb-xs
      AppImg(srcset="https://baianat.s3.amazonaws.com/highlights/Untitled-2_1547502077710_w92175.jpg" ratio="5:2" autoRatio alt="Abstract art image")
    AppLink(class="button-link" to="/moments" :title="$t('seeMore')") {{$t('seeMore')}}

  section.u-mt-md
    AppTitle(:title="$t('approach')" tag="h2")
    .grid.is-widescreen-7.is-desktop-9
      .column
        p.u-text-lg.u-mb-xs {{$t('approachDesc')}}
    AppLink(class="button-link" to="/culture/approach" :title="$t('approachCta')") {{$t('approachCta')}}


  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('values')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('valuesItems')")
            h4 {{item.title}}
            p {{item.desc}}
        AppLink(to="/culture/values" :title="$t('valuesCta')" class="button-link") {{$t('valuesCta')}}

  section.u-mt-md
    .grid.is-middle
      .column.is-widescreen-5.u-mb-sm
        AppCardBox
          h3 {{ $t('culture') }}
          p {{ $t('cultureDesc') }}
          .u-mt-xs
            AppLink(to="/culture" :title="$t('cultureCta')" class="button-link is-medium ") {{ $t('cultureCta') }}
      .column.is-widescreen-7.u-mb-sm
        AppCardBox
          h3 {{ $t('history') }}
          p {{ $t('historyDesc') }}
          .u-mt-xs
            AppLink(to="/company/history" :title="$t('historyCta')" class="button-link is-medium ") {{ $t('historyCta') }}


  section.u-mt-md.u-mb-md
    AppLink(to="/follow" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")


</template>

<script>
import { Articles } from '~/graphql/Article.gql';
import { load } from '~/directives';

export default {
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share.png'
        }
      ]
    };
  },

  directives: {
    load
  },
  data() {
    return {
      images: [
        [
          {
            srcset: '{CDN_URL}/agency/01@2x.webp 2x, {CDN_URL}/agency/01.webp 1x',
            isUltra: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/01@2x.webp 2x, {CDN_URL}/agency/desktop/01.webp 1x',
            isDesktop: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/01@2x.webp 2x, {CDN_URL}/agency/tablet/01.webp 1x',
            isTablet: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/01@2x.webp 2x, {CDN_URL}/agency/mobile/01.webp 1x',
            isMobile: true,
            type: 'image/webp'
          },
          { srcset: '{CDN_URL}/agency/01.webp', type: 'image/webp' },

          {
            srcset: '{CDN_URL}/agency/01@2x.jpg 2x, {CDN_URL}/agency/01.jpg 1x',
            isUltra: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/01@2x.jpg 2x, {CDN_URL}/agency/desktop/01.jpg 1x',
            isDesktop: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/01@2x.jpg 2x, {CDN_URL}/agency/tablet/01.jpg 1x',
            isTablet: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/01@2x.jpg 2x, {CDN_URL}/agency/mobile/01.jpg 1x',
            isMobile: true,
            type: 'image/jpg'
          },
          { srcset: '{CDN_URL}/agency/01.jpg', type: 'image/jpg' }
        ],
        [
          {
            srcset: '{CDN_URL}/agency/02@2x.webp 2x, {CDN_URL}/agency/02.webp 1x',
            isUltra: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/02@2x.webp 2x, {CDN_URL}/agency/desktop/02.webp 1x',
            isDesktop: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/02@2x.webp 2x, {CDN_URL}/agency/tablet/02.webp 1x',
            isTablet: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/02@2x.webp 2x, {CDN_URL}/agency/mobile/02.webp 1x',
            isMobile: true,
            type: 'image/webp'
          },
          { srcset: '{CDN_URL}/agency/02.webp', type: 'image/webp' },

          {
            srcset: '{CDN_URL}/agency/02@2x.jpg 2x, {CDN_URL}/agency/02.jpg 1x',
            isUltra: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/02@2x.jpg 2x, {CDN_URL}/agency/desktop/02.jpg 1x',
            isDesktop: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/02@2x.jpg 2x, {CDN_URL}/agency/tablet/02.jpg 1x',
            isTablet: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/02@2x.jpg 2x, {CDN_URL}/agency/mobile/02.jpg 1x',
            isMobile: true,
            type: 'image/jpg'
          },
          { srcset: '{CDN_URL}/agency/02.jpg', type: 'image/jpg' }
        ],
        [
          {
            srcset: '{CDN_URL}/agency/04@2x.webp 2x, {CDN_URL}/agency/04.webp 1x',
            isUltra: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/04@2x.webp 2x, {CDN_URL}/agency/desktop/04.webp 1x',
            isDesktop: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/04@2x.webp 2x, {CDN_URL}/agency/tablet/04.webp 1x',
            isTablet: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/04@2x.webp 2x, {CDN_URL}/agency/mobile/04.webp 1x',
            isMobile: true,
            type: 'image/webp'
          },
          { srcset: '{CDN_URL}/agency/04.webp', type: 'image/webp' },

          {
            srcset: '{CDN_URL}/agency/04@2x.jpg 2x, {CDN_URL}/agency/04.jpg 1x',
            isUltra: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/04@2x.jpg 2x, {CDN_URL}/agency/desktop/04.jpg 1x',
            isDesktop: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/04@2x.jpg 2x, {CDN_URL}/agency/tablet/04.jpg 1x',
            isTablet: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/04@2x.jpg 2x, {CDN_URL}/agency/mobile/04.jpg 1x',
            isMobile: true,
            type: 'image/jpg'
          },
          { srcset: '{CDN_URL}/agency/04.jpg', type: 'image/jpg' }
        ],
        [
          {
            srcset: '{CDN_URL}/agency/03@2x.webp 2x, {CDN_URL}/agency/03.webp 1x',
            isUltra: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/03@2x.webp 2x, {CDN_URL}/agency/desktop/03.webp 1x',
            isDesktop: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/03@2x.webp 2x, {CDN_URL}/agency/tablet/03.webp 1x',
            isTablet: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/03@2x.webp 2x, {CDN_URL}/agency/mobile/03.webp 1x',
            isMobile: true,
            type: 'image/webp'
          },
          { srcset: '{CDN_URL}/agency/03.webp', type: 'image/webp' },

          {
            srcset: '{CDN_URL}/agency/03@2x.jpg 2x, {CDN_URL}/agency/03.jpg 1x',
            isUltra: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/03@2x.jpg 2x, {CDN_URL}/agency/desktop/03.jpg 1x',
            isDesktop: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/03@2x.jpg 2x, {CDN_URL}/agency/tablet/03.jpg 1x',
            isTablet: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/03@2x.jpg 2x, {CDN_URL}/agency/mobile/03.jpg 1x',
            isMobile: true,
            type: 'image/jpg'
          },
          { srcset: '{CDN_URL}/agency/03.jpg', type: 'image/jpg' }
        ],
        [
          {
            srcset: '{CDN_URL}/agency/05@2x.webp 2x, {CDN_URL}/agency/05.webp 1x',
            isUltra: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/05@2x.webp 2x, {CDN_URL}/agency/desktop/05.webp 1x',
            isDesktop: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/05@2x.webp 2x, {CDN_URL}/agency/tablet/05.webp 1x',
            isTablet: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/05@2x.webp 2x, {CDN_URL}/agency/mobile/05.webp 1x',
            isMobile: true,
            type: 'image/webp'
          },
          { srcset: '{CDN_URL}/agency/05.webp', type: 'image/webp' },

          {
            srcset: '{CDN_URL}/agency/05@2x.jpg 2x, {CDN_URL}/agency/05.jpg 1x',
            isUltra: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/05@2x.jpg 2x, {CDN_URL}/agency/desktop/05.jpg 1x',
            isDesktop: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/05@2x.jpg 2x, {CDN_URL}/agency/tablet/05.jpg 1x',
            isTablet: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/05@2x.jpg 2x, {CDN_URL}/agency/mobile/05.jpg 1x',
            isMobile: true,
            type: 'image/jpg'
          },
          { srcset: '{CDN_URL}/agency/05.jpg', type: 'image/jpg' }
        ]
      ]
    };
  },
  async asyncData({ app }) {
    const { data } = await app.$api.query({
      query: Articles,
      variables: {
        publishedIn: 'PRESS',
        skip: 0,
        limit: 2
      }
    });

    return {
      articles: data.articles,
      isFetching: false
    };
  },
  methods: {
    async fetchMore() {
      try {
        this.isFetching = true;
        const { data } = await this.$api.query({
          query: Articles,
          variables: {
            publishedIn: 'PRESS',
            skip: this.articles.items.length,
            limit: 10
          }
        });

        this.articles.pageInfo = data.articles.pageInfo;
        this.articles.items = Object.freeze([...this.articles.items, ...data.articles.items]);
      } catch (err) {
        console.log(err);
      } finally {
        this.isFetching = false;
      }
    }
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"About Baianat",
    "pageDesc":"We are Baianat, a multidisciplinary company with a detail oriented mentality. Read more about our culture, history and inside moments.",
    "mantra":"We are Baianat, Inc",
    "mantraDesc":"Started back in 2000 with a mission of changing cultures and impacting humanity positively. And over the years, we tried to follow an authentic approach to produce solutions that boost businesses' performance and become part of people’s lifestyle.",
    "meet":"Meet the |Baianaters",
    "meetDesc":"We are a team of believers driven by culture and authenticity. We act as one and follow our hearts and processes to create customer centric solutions. ",
    "approach":"Approach",
    "approachDesc":"Playing by our rules to create products that carries our souls and have the Baianaters identity.",
    "approachCta":"See our approach",
    "approachItems":{
      "1":{
        "title":"Lean production",
        "desc":"We allocate our resources into what matters, and fight feature creep; the result is a functioning prototype in less time with all needed features."
      },
      "2":{
        "title":"Small teams",
        "desc":"You don’t need an army to build a solution. Sometimes all it takes is just two crazy believers who think that they can change the world with their ideas."
      },
      "3":{
        "title":"Iteration",
        "desc":"Perfection takes versions, and as there are a million ways of connecting the dots; we try different routes until we find the perfect one."
      },
      "4":{
        "title":"Cutting edge technology",
        "desc":"We keep ourselves up to date with the latest technologies, so when projects come in, we select the best and latest working methodology."
      },
      "5":{
        "title":"Working closely",
        "desc":"No one knows the industry better than someone who has worked on it for years, so we work closely with our partners on their dream. Together we tailor every pixel and line of code to match their ideal story."
      },
      "6":{
        "title":"Strategy driven",
        "desc":"It’s not about what we like. It’s not about what clients want. It’s about what users need. And when it comes to users, we rely on data, not guesses."
      }
    },
    "values":"Guided by values.",
    "valuesItems":{
      "1":{
        "title":"Authenticity",
        "desc":"We pour our souls into everything we do, and take pride in ourselves and our visions. That’s why we create things in our own way, and add unexpected twists to every project."
      },
      "2":{
        "title":"Credibility",
        "desc":"Walking the talk, and talking the walk. We respect the trust our partners put in us and take the responsibility of meeting the image created in their minds."
      },
      "3":{
        "title":"Transparency",
        "desc":"No secrets. No barriers. We work closely with our partners to create projects of value. When issues arise, we address it together, and talk freely over anything, and everything."
      }
    },
    "valuesCta":"View our values",
    "culture":"Culture",
    "cultureDesc":"With values in heart, and targets in mind, we checkmate games, and take actions on the ground.",
    "cultureCta":"Read our culture",
    "history":"History",
    "historyDesc":"Milestones, stories, and experiences that shaped who we are today.",
    "historyCta":"Read our history",
    "cta":"Follow us on our <br> social media channels."

  },
  "ar": {
    "pageTitle":"عن بيانات",
    "pageDesc":"بيانات شركة متعددة التخصصات بعقلية تهتم بالتفاصيل، اقرأ المزيد عن ثقافتنا وتاريخنا ولحظاتنا التي تحدث خلف الكواليس.",
    "mantra":"اقترب أكثر من |عالم بيانات. ",
    "mantraDesc":"بدأت شركة بيانات في عام 2000 وتتمحور مهمتها حول تغيير الثقافات والتأثير على البشرية بشكل إيجابي. وعلى مر السنوات، حاولنا اتباع نهج حقيقي لإنتاج حلول تعزز أداء الشركات وتصبح جزءًا من أسلوب حياة الأفراد.",
    "meet":"تقابل مع |Baianaters",
    "meetDesc":"نحن فريق نؤمن بكل ما نقوم به تقودنا الثقافة والأصالة. نتعاون سويًا ونعمل بمثابة فرد واحد من أجل تقديم خدمات مميزة تدعم نجاح ونمو عملائنا.",
    "approach":"المنهج",
    "approachDesc":"نلعب وفقًا للقواعد التي تساعدنا على خلق منتجات وخدمات فريدة من نوعها تحمل روح هويتنا وتعبر عن أرواحنا.",
    "approachCta":"تعرف على منهجنا",
    "approachItems":{
      "1":{
        "title":"الإنتاج المرن",
        "desc":"نُخصص مواردنا فيما يهم، ونبتعد عن إضافة المميزات الكثيرة التى لا جدوى منها. والنتيجة هي نموذج أولى فعال في وقت أقل، ويحتوى على جميع المميزات المطلوبة."
      },
      "2":{
        "title":"فرق صغيرة",
        "desc":"لست بحاجة إلى بناء فرق هائلة العدد لإيجاد الحلول. في بعض الأحيان لا يتطلب الأمر سوى اثنين من المؤمنين بالأفكار الذين يعتقدون أن بإمكانهم تغيير العالم."
      },
      "3":{
        "title":"المراجعات المستمرة",
        "desc":"الكمال يتطلب العديد من الإصدارات. وبما أن هناك مليون طريقة لربط النقاط، فنحن نجرب طرقًا مختلفة لنصل إلى المثالية منها."
      },
      "4":{
        "title":"أحدث التقنيات",
        "desc":"نطلع دائماً على أحدث التقنيات. ولذلك عندما نحصل على مشروع جديد، نكون قادرين على اختيار أفضل وأحدث المنهجيات للعمل."
      },
      "5":{
        "title":"نعمل عن قُرب",
        "desc":"لا أحد يعرف الصناعة بشكل أفضل مِن شخص عمل فيها لسنوات. لذلك نعمل عن كَثَب مع شركاء النجاح في تحقيق أحلامهم. معاً، نقوم بتخطيط كل بكسل و رمز برمجي لتتناسب مع قصصهم المثالية"
      },
      "6":{
        "title":"الاستراتيجية أولًا",
        "desc":"الأمر لا يتعلق بما نحب، ولا بما يريده العملاء. إنما يتعلق بما يحتاجه المستخدمون. وعندما يتعلق الأمر بالمستخدمين، فإننا نعتمد على البيانات لا على التخمين."
      }
    },
    "values":"القيم التي لا نتنازل عنها.",
    "valuesItems":{
      "1":{
        "title":"الأصالة",
        "desc":"تنغمس أرواحنا في كل شيء نقوم به. نفخر بأنفسنا و بالرؤى الخاصة بنا، لهذا نصنع الأشياء على طريقتنا الخاصة، ونضيف إليها ما هو غير متوقع في كل مرة."
      },
      "2":{
        "title":"المصداقية",
        "desc":"أفعالنا هي ما تتحدث عنا. نحترم الثقة التي وضعها شركاء النجاح فينا، ونتحمل مسؤولية تلبية الانطباع الذي تكون في أذهانهم عنا."
      },
      "3":{
        "title":"الشفافية",
        "desc":"ليس لدينا أسرار أو حواجز، نعمل عن قرب مع شركاء النجاح لإنشاء مشروعات ذات قيمة. عندما تظهر أى مشكلة، نتناولها سويًا ونتحدث بحرية حول أي شيء وكل شيء."
      }
    },
    "valuesCta":"أقرأ قيمنا",
    "history":"التاريخ",
    "historyDesc":"الأحداث الهامة والقصص والخبرات التى شكلت ما نحن عليه الآن.",
    "historyCta":"اقرأ تاريخنا",

    "culture":"الثقافة",
    "cultureDesc":"نحمل القيم والمبادئ في قلوبنا لأنها تُرشدنا نحو الصواب طوال الطريق. ونتحقق مما نقوم به؛ لنتخذ الإجراءات الصحيحة.",
    "cultureCta":"اقرأ ثقافتنا",
    "cta":"تابعنا على قنوات <br> التواصل الإجتماعى"
  }
}
</i18n>
